import prescriptionService from '@webServices/prescription.service';
import { element, elements, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { addCss, removeCss } from '@shared/easyfy.utils';
import PrescriptionModal, {
  ModalType
} from '@webModules/prescriptionModal';
import '@webModules/scrollState';

namespace Easyfy.Web.Pages.DrugList {
  @invoke
  class MyDrugLists {
    static Instance: MyDrugLists;

    static drugListsElement: HTMLElement;

    static disabledClass = 'disabled';

    private modal: PrescriptionModal;

    constructor() {
      MyDrugLists.Instance = this;
      MyDrugLists.Instance.modal = new PrescriptionModal();
    }

    onInit() {
      globalEvent({
        type: 'change',
        event: {
          action: 'toggle-risk-checkbox',
          callback: MyDrugLists.ToggleRiskCheckbox
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'drug-list-modal',
          callback: MyDrugLists.GetDrugListModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'saved-prescriptions-modal',
          callback: MyDrugLists.GetSavedPrescriptionsModal
        }
      });

      MyDrugLists.drugListsElement = element(
        '[data-container="drug-lists"]'
      ) as HTMLElement;

      if (
        MyDrugLists.drugListsElement &&
        MyDrugLists.drugListsElement.attributes['data-loaded']?.value === 'false'
      ) {
        MyDrugLists.LoadDrugLists();
      }
    }

    static LoadDrugLists = () => {
      prescriptionService
        .GetDrugLists()
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            if (MyDrugLists.drugListsElement) {
              MyDrugLists.drugListsElement.innerHTML =
                response.data.drugListPartial;
              MyDrugLists.drugListsElement.setAttribute('data-loaded', 'true');
            }
          } else {
            MyDrugLists.drugListsElement.innerHTML = '';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    static ToggleRiskCheckbox = (e) => {
      const riskCheckbox = event.target as HTMLInputElement;
      const drugLists = elements('.drug-list');

      if (drugLists && drugLists.length > 0) {
        drugLists.forEach((drugList: HTMLElement) => {
          if (riskCheckbox.checked) {
            removeCss(drugList, MyDrugLists.disabledClass);
          } else {
            addCss(drugList, MyDrugLists.disabledClass);
          }
        });
      }
    };

    static GetDrugListModal = () => {
      event.preventDefault();
      event.stopPropagation();

      const addToElement = element(
        '[data-container="drug-list-page"]'
      ) as HTMLElement;

      if (addToElement) {
        MyDrugLists.Instance.modal.AppendModal(
          ModalType.DrugList,
          addToElement
        );
      }
    };

    static GetSavedPrescriptionsModal = () => {
      event.preventDefault();
      event.stopPropagation();

      const addToElement = element(
        '[data-container="drug-list-page"]'
      ) as HTMLElement;

      if (addToElement) {
        MyDrugLists.Instance.modal.AppendModal(
          ModalType.SavedPrescriptions,
          addToElement
        );
      }
    };
  }
}

export default Easyfy.Web.Pages;
